<div class="flex flex-row p-4 mb-4 bg-green-500 rounded">
  <div class="flex items-center mr-4">
    <mat-icon class="text-white transform scale-150">check_circle_outline</mat-icon>
  </div>
  <ng-content></ng-content>
</div>
